/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';

export const AdminConfigGet = {
  id: 'admin-config.get',
  tag: 'Admin',
  summary: 'Admin Config',
  description: 'Get all admin config',
  method: 'get',
  flags: { isAuthorized: true, isSuperuser: true },
  route: () => `/administration/config`,
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(
            z.strictObject({
              configData: z.strictObject({
                email: z.string(),
                token: z.string(),
                serviceDeskKey: z.string(),
                serviceDeskId: z.string(),
                atlassianUrl: z.string(),
              }),
            }),
          ),
        },
      },
    },
  },
} as const satisfies Endpoint;
